import React from 'react';

const BurgerMenu = () => (
  <path d="M7 9h18c1.3333 0 1.3333 2 0 2H7c-1.3333 0-1.3333-2 0-2zm0 6h18c1.3333 0 1.3333 2 0 2H7c-1.3333 0-1.3333-2 0-2zm0 6h18c1.3333 0 1.3333 2 0 2H7c-1.3333 0-1.3333-2 0-2z" />
);

export default BurgerMenu;
